import React, { useEffect } from 'react'
// import * as alasql from './alasql'
import * as alasql from 'alasql';
const data = [
    {
        "city": "Madrid",
        "population": 3041579
    },
    {
        "city": "Rome",
        "population": 2863223
    },
    {
        "city": "Paris",
        "population": 2249975
    }
]
const mystyle = {
    headers: true,
    column: { style: { Font: { Bold: "1" }, Fill: { Color: "#000000" }, Alignment: { Horizontal: "Center" }, textAlign: "center" } },
    //rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
    cells: {
        1: {
            1: {
                style: { Fill: { Color: "#000000" } }
            }
        }
    }
};



const Exporting = ({ columns, exportDataModel = { dataList: [], exportingWaiting: false } }) => {
    const [isInprogress, setInProgress] = React.useState(false)


    React.useEffect(() => {
        if (exportDataModel.dataList && isInprogress) {
            handleTest()

        }
    }, [exportDataModel.dataList])


    const handleTest = () => {
        setInProgress(false)
        let queryStr = `SELECT ${columns.filter(item => item.show).map(item => item.property + ` AS [` + item.title + `] `)
            } INTO XLSXML("${exportDataModel.fileName ? exportDataModel.fileName : "TableExport"}.xls",?) FROM ?`
        alasql.promise(queryStr, [mystyle, exportDataModel.dataList])
            .then(function (data) {

            }).catch(function (err) {
                console.log('Error:', err);
            });
    }

    return (
        <li onClick={() => { exportDataModel.callAPIToExport(); setInProgress(true) }}>خروجی اکسل</li>
    )
}

export default Exporting